(function () {
  function parseData(root) {
    var script = root.querySelector('[data-film-archive-data]');
    if (!script) return { films: [] };

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('Film archive data could not be parsed', error);
      return { films: [] };
    }
  }

  function randomIndex(max) {
    if (window.crypto && window.crypto.getRandomValues) {
      var values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return values[0] % max;
    }

    return Math.floor(Math.random() * max);
  }

  function shuffleList(items) {
    var shuffled = items.slice();

    for (var index = shuffled.length - 1; index > 0; index -= 1) {
      var swapIndex = randomIndex(index + 1);
      var current = shuffled[index];
      shuffled[index] = shuffled[swapIndex];
      shuffled[swapIndex] = current;
    }

    return shuffled;
  }

  function getFrameOrientation(frame) {
    if (frame.dataset.frameOrientation) return frame.dataset.frameOrientation;

    var ratioValue = frame.style.getPropertyValue('--frame-ratio') || '';
    var ratioParts = ratioValue.split('/');
    var width = parseFloat(ratioParts[0]);
    var height = parseFloat(ratioParts[1]);
    var ratio = width && height ? width / height : 1;
    var orientation = 'square';

    if (ratio > 1.08) orientation = 'horizontal';
    if (ratio < 0.92) orientation = 'vertical';

    frame.dataset.frameOrientation = orientation;
    return orientation;
  }

  function isVishalFrame(frame) {
    return (frame.dataset.frameCredit || '').trim().toLowerCase() === 'vishal kullarwar';
  }

  function getRecentFrames(order, windowSize) {
    return order.slice(Math.max(order.length - windowSize, 0));
  }

  function countRecentMatches(order, frame, windowSize, matcher) {
    return getRecentFrames(order, windowSize).filter(function (recentFrame) {
      return matcher(recentFrame, frame);
    }).length;
  }

  function scoreFrameForPosition(frame, order, remainingCount) {
    var orientation = getFrameOrientation(frame);
    var sameOrientationNearby = countRecentMatches(order, frame, 5, function (recentFrame) {
      return getFrameOrientation(recentFrame) === orientation;
    });
    var sameFilmNearby = countRecentMatches(order, frame, 8, function (recentFrame) {
      return recentFrame.dataset.filmSlug === frame.dataset.filmSlug;
    });
    var vishalNearby = countRecentMatches(order, frame, 5, function (recentFrame) {
      return isVishalFrame(recentFrame);
    });
    var score = randomIndex(1000) / 1000;

    score -= sameOrientationNearby * 18;
    score -= sameFilmNearby * 8;

    if (orientation === 'square') score += 2;
    if (isVishalFrame(frame)) {
      var progress = order.length / Math.max(order.length + remainingCount, 1);
      score += (1 - progress) * 7;
      score -= vishalNearby * 12;
    }

    return score;
  }

  function buildBalancedFrameOrder(frames) {
    var remaining = shuffleList(frames);
    var order = [];

    while (remaining.length) {
      var bestFrameIndex = 0;
      var bestScore = -Infinity;

      remaining.forEach(function (frame, index) {
        var score = scoreFrameForPosition(frame, order, remaining.length);
        if (score <= bestScore) return;
        bestScore = score;
        bestFrameIndex = index;
      });

      order.push(remaining.splice(bestFrameIndex, 1)[0]);
    }

    return order;
  }

  function selectTopVishalFrames(frames, count) {
    var remaining = shuffleList(frames.filter(isVishalFrame));
    var selected = [];

    while (remaining.length && selected.length < count) {
      var bestFrameIndex = 0;
      var bestScore = -Infinity;

      remaining.forEach(function (frame, index) {
        var sameFilmCount = selected.filter(function (selectedFrame) {
          return selectedFrame.dataset.filmSlug === frame.dataset.filmSlug;
        }).length;
        var sameOrientationCount = selected.filter(function (selectedFrame) {
          return getFrameOrientation(selectedFrame) === getFrameOrientation(frame);
        }).length;
        var score = randomIndex(1000) / 1000;

        score -= sameFilmCount * 20;
        score -= sameOrientationCount * 5;

        if (score <= bestScore) return;
        bestScore = score;
        bestFrameIndex = index;
      });

      selected.push(remaining.splice(bestFrameIndex, 1)[0]);
    }

    return selected;
  }

  function buildCuratedFrameOrder(frames) {
    var topVishalFrames = selectTopVishalFrames(frames, Math.min(3, frames.length));
    var remainingFrames = frames.filter(function (frame) {
      return topVishalFrames.indexOf(frame) === -1;
    });
    var order = buildBalancedFrameOrder(remainingFrames);
    var topPositions = [0, 3, 6];

    topVishalFrames.forEach(function (frame, index) {
      order.splice(Math.min(topPositions[index], order.length), 0, frame);
    });

    return order;
  }

  function getPanelFrameMatcher(panel) {
    var selectedSlug = panel.dataset.filmArchiveSelectedSlug || '';
    var selectedFormat = panel.dataset.filmArchiveSelectedFormat || '';
    var selectedStatus = panel.dataset.filmArchiveSelectedStatus || '';

    return function (frame) {
      var filmMatches = !selectedSlug || frame.dataset.filmSlug === selectedSlug;
      var formatMatches = filmHasFormat(frame.dataset.filmFormat, selectedFormat);
      var statusMatches = !selectedStatus || (selectedStatus === 'expired'
        ? frame.dataset.filmExpired === 'true'
        : frame.dataset.filmExpired !== 'true');
      return filmMatches && formatMatches && statusMatches;
    };
  }

  function normalizeFilmFormat(value) {
    var normalized = String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    if (normalized.indexOf('35') !== -1) return '35mm';
    if (/(^|\s)120(\s|$)/.test(normalized)) return '120';
    if (/(^|[^0-9])4\s*[x×]\s*5([^0-9]|$)/.test(normalized)) return '4x5';
    return '';
  }

  function filmHasFormat(value, selectedFormat) {
    if (!selectedFormat) return true;
    var normalized = String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    if (selectedFormat === '35mm') return /35\s*mm/.test(normalized);
    if (selectedFormat === '120') return /(^|[^0-9])120([^0-9]|$)/.test(normalized);
    if (selectedFormat === '4x5') return /(^|[^0-9])4\s*[x×]\s*5([^0-9]|$)/.test(normalized);
    return false;
  }

  function shufflePanelFrames(panel, matchFrame) {
    var cascade = panel.querySelector('[data-film-archive-cascade]');
    if (!cascade) return;

    var frames = Array.prototype.slice.call(cascade.querySelectorAll('[data-film-archive-frame]'));
    if (frames.length < 2) return;
    var matcher = matchFrame || function () { return true; };
    var matchingFrames = frames.filter(matcher);
    var remainingFrames = frames.filter(function (frame) {
      return matchingFrames.indexOf(frame) === -1;
    });
    var orderedFrames = buildCuratedFrameOrder(matchingFrames).concat(shuffleList(remainingFrames));

    orderedFrames.forEach(function (frame) {
      cascade.appendChild(frame);
    });
  }

  function shuffleArchiveFrames(root) {
    root.querySelectorAll('[data-film-archive-panel]').forEach(function (panel) {
      shufflePanelFrames(panel);
    });
  }

  function init(root) {
    if (root.dataset.filmArchiveInitialized === 'true' || root.dataset.filmArchiveInitialized === 'initializing') return;
    root.dataset.filmArchiveInitialized = 'initializing';

    try {

    var data = parseData(root);
    var films = data.films || [];
    var tabs = root.querySelectorAll('[data-film-archive-tab]');
    var panels = root.querySelectorAll('[data-film-archive-panel]');
    var viewer = root.querySelector('[data-film-archive-viewer]');
    var viewerImage = root.querySelector('[data-film-archive-viewer-image]');
    var viewerFilm = root.querySelector('[data-film-archive-viewer-film]');
    var viewerExpired = root.querySelector('[data-film-archive-viewer-expired]');
    var viewerExpiredRow = root.querySelector('[data-film-archive-viewer-expired-row]');
    var viewerFormat = root.querySelector('[data-film-archive-viewer-format]');
    var viewerFormatRow = root.querySelector('[data-film-archive-viewer-format-row]');
    var viewerRespool = root.querySelector('[data-film-archive-viewer-respool]');
    var viewerRespoolRow = root.querySelector('[data-film-archive-viewer-respool-row]');
    var viewerIso = root.querySelector('[data-film-archive-viewer-iso]');
    var viewerCredit = root.querySelector('[data-film-archive-viewer-credit]');
    var viewerProcess = root.querySelector('[data-film-archive-viewer-process]');
    var viewerLab = root.querySelector('[data-film-archive-viewer-lab]');
    var viewerLabRow = root.querySelector('[data-film-archive-viewer-lab-row]');
    var viewerPush = root.querySelector('[data-film-archive-viewer-push]');
    var viewerNotes = root.querySelector('[data-film-archive-viewer-notes]');
    var viewerNotesRow = root.querySelector('[data-film-archive-viewer-notes-row]');
    var viewerBuy = root.querySelector('[data-film-archive-viewer-buy]');
    var viewerClose = root.querySelector('[data-film-archive-viewer-close]');
    var backTop = root.querySelector('[data-film-archive-back-top]');
    var lastFocusedFrame = null;
    var productCatalogPromise;
    var viewerRequest = 0;

    function filmSignature(name) {
      return String(name || '').toLowerCase()
        .replace(/\([^)]*\)/g, ' ')
        .replace(/\b(the panchrome project|tpp|kodak|professional|expired|film|films)\b/g, ' ')
        .replace(/[^a-z0-9]/g, '');
    }

    function findFilmProduct(frame) {
      if (!productCatalogPromise) {
        productCatalogPromise = Promise.all(['fresh-films', 'expired-films'].map(function (collection) {
          function loadPage(page) {
            return fetch('/collections/' + collection + '/products.json?limit=250&page=' + page)
              .then(function (response) {
                if (!response.ok) throw new Error('Product lookup failed');
                return response.json();
              })
              .then(function (data) {
                var products = data.products || [];
                return products.length === 250
                  ? loadPage(page + 1).then(function (next) { return products.concat(next); })
                  : products;
              });
          }
          return loadPage(1);
        })).catch(function (error) {
          productCatalogPromise = null;
          throw error;
        });
      }
      return productCatalogPromise.then(function (collections) {
        var preferred = frame.dataset.filmExpired === 'true' ? 1 : 0;
        var signature = filmSignature(frame.dataset.filmName);
        var product = collections[preferred].concat(collections[1 - preferred]).find(function (item) {
          return signature && filmSignature(item.title) === signature;
        });
        return product ? '/products/' + product.handle : '';
      });
    }

    shuffleArchiveFrames(root);

    function getBatchSize() {
      return 25;
    }

    function getMasonryColumnCount() {
      if (window.innerWidth <= 420) return 1;
      if (window.innerWidth <= 640) return 2;
      if (window.innerWidth <= 989) return 3;
      return 4;
    }

    function layoutPanelMasonry(panel) {
      var cascade = panel && panel.querySelector('[data-film-archive-cascade]');
      if (!cascade) return;
      var frames = Array.prototype.slice.call(cascade.querySelectorAll('[data-film-archive-frame]'));
      var visibleFrames = frames.filter(function (frame) { return !frame.hidden; });
      var styles = window.getComputedStyle(cascade);
      var gap = parseFloat(styles.getPropertyValue('--archive-masonry-gap')) || 8;
      var paddingLeft = parseFloat(styles.paddingLeft) || 0;
      var paddingRight = parseFloat(styles.paddingRight) || 0;
      var columns = getMasonryColumnCount();
      var availableWidth = Math.max(0, cascade.clientWidth - paddingLeft - paddingRight);
      var itemWidth = Math.max(0, (availableWidth - gap * (columns - 1)) / columns);
      var columnHeights = Array(columns).fill(0);
      cascade.classList.add('is-js-masonry');
      frames.forEach(function (frame) {
        if (!frame.hidden) return;
        frame.style.removeProperty('left');
        frame.style.removeProperty('top');
        frame.style.removeProperty('width');
      });
      visibleFrames.forEach(function (frame) {
        var targetColumn = columnHeights.indexOf(Math.min.apply(Math, columnHeights));
        frame.style.width = itemWidth + 'px';
        frame.style.left = (paddingLeft + targetColumn * (itemWidth + gap)) + 'px';
        frame.style.top = columnHeights[targetColumn] + 'px';
        columnHeights[targetColumn] += frame.offsetHeight + gap;
      });
      var masonryHeight = visibleFrames.length ? Math.max.apply(Math, columnHeights) - gap : 0;
      cascade.style.height = Math.max(0, masonryHeight) + 'px';
    }

    function schedulePanelMasonry(panel) {
      window.requestAnimationFrame(function () { layoutPanelMasonry(panel); });
    }

    function resetPanelLimit(panel) {
      panel.dataset.filmArchiveVisibleLimit = String(getBatchSize());
    }

    function getMatchingFrames(panel) {
      var selectedSlug = panel.dataset.filmArchiveSelectedSlug || '';
      var selectedFormat = panel.dataset.filmArchiveSelectedFormat || '';
      var selectedStatus = panel.dataset.filmArchiveSelectedStatus || '';
      var frames = Array.prototype.slice.call(panel.querySelectorAll('[data-film-archive-frame]'));

      return frames.filter(function (frame) {
        var filmMatches = !selectedSlug || frame.dataset.filmSlug === selectedSlug;
        var formatMatches = filmHasFormat(frame.dataset.filmFormat, selectedFormat);
        var statusMatches = !selectedStatus || (selectedStatus === 'expired'
          ? frame.dataset.filmExpired === 'true'
          : frame.dataset.filmExpired !== 'true');
        return filmMatches && formatMatches && statusMatches;
      });
    }

    function increasePanelLimit(panel) {
      if (!panel) return;
      var matchingFrames = getMatchingFrames(panel);
      var currentLimit = parseInt(panel.dataset.filmArchiveVisibleLimit || getBatchSize(), 10);
      if (currentLimit >= matchingFrames.length) return;

      var nextLimit = Math.min(currentLimit + getBatchSize(), matchingFrames.length);
      var revealedFrames = matchingFrames.slice(currentLimit, nextLimit);
      panel.dataset.filmArchiveVisibleLimit = String(nextLimit);
      filterPanel(panel);

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      revealedFrames.forEach(function (frame, index) {
        frame.classList.remove('is-load-more-reveal');
        frame.style.setProperty('--archive-reveal-index', String(index));
      });

      window.requestAnimationFrame(function () {
        revealedFrames.forEach(function (frame) {
          frame.classList.add('is-load-more-reveal');
          frame.addEventListener('animationend', function () {
            frame.classList.remove('is-load-more-reveal');
            frame.style.removeProperty('--archive-reveal-index');
          }, { once: true });
        });
      });
    }

    function closeDropdown(dropdown) {
      var toggle = dropdown.querySelector('[data-film-archive-dropdown-toggle]');
      var menu = dropdown.querySelector('[data-film-archive-dropdown-menu]');
      if (!toggle || !menu) return;
      toggle.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    }

    function updatePanelMeta(panel) {
      var countNode = panel.querySelector('[data-film-archive-count]');
      var imageCountNode = panel.querySelector('[data-film-archive-image-count]');
      var matchingFrames = getMatchingFrames(panel);
      var filmSlugs = matchingFrames.reduce(function (slugs, frame) {
        if (frame.dataset.filmSlug && slugs.indexOf(frame.dataset.filmSlug) === -1) {
          slugs.push(frame.dataset.filmSlug);
        }
        return slugs;
      }, []);
      var stockCount = filmSlugs.length;
      var imageCount = matchingFrames.length;

      if (countNode) countNode.textContent = stockCount + (stockCount === 1 ? ' film stock' : ' film stocks');
      if (imageCountNode) imageCountNode.textContent = imageCount + (imageCount === 1 ? ' image' : ' images');
    }

    function filterPanel(panel, slug, label) {
      var visibleCount = 0;
      var frames = panel.querySelectorAll('[data-film-archive-frame]');
      var empty = panel.querySelector('[data-film-archive-empty]');
      var loadMore = panel.querySelector('[data-film-archive-load-more]');
      var selectedSlug = typeof slug === 'string' ? slug : panel.dataset.filmArchiveSelectedSlug || '';
      var selectedFormat = panel.dataset.filmArchiveSelectedFormat || '';
      var selectedStatus = panel.dataset.filmArchiveSelectedStatus || '';
      var visibleLimit = parseInt(panel.dataset.filmArchiveVisibleLimit || getBatchSize(), 10);

      frames.forEach(function (frame) {
        var filmMatches = !selectedSlug || frame.dataset.filmSlug === selectedSlug;
        var formatMatches = filmHasFormat(frame.dataset.filmFormat, selectedFormat);
        var statusMatches = !selectedStatus || (selectedStatus === 'expired'
          ? frame.dataset.filmExpired === 'true'
          : frame.dataset.filmExpired !== 'true');
        var visible = filmMatches && formatMatches && statusMatches && visibleCount < visibleLimit;
        frame.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      var filmLabelNode = panel.querySelector('[data-film-filter-kind="film"] [data-film-archive-dropdown-label]');
      var formatLabelNode = panel.querySelector('[data-film-filter-kind="format"] [data-film-archive-dropdown-label]');
      var statusLabelNode = panel.querySelector('[data-film-filter-kind="status"] [data-film-archive-dropdown-label]');
      if (filmLabelNode && typeof label === 'string') filmLabelNode.textContent = label || 'Choose a film';
      if (formatLabelNode) formatLabelNode.textContent = selectedFormat || 'Film Format';
      if (statusLabelNode) statusLabelNode.textContent = selectedStatus === 'expired' ? 'Expired' : selectedStatus === 'fresh' ? 'Regular' : 'Film Condition';
      if (empty) empty.hidden = visibleCount > 0;
      if (loadMore) loadMore.hidden = visibleCount >= getMatchingFrames(panel).length;
      updatePanelMeta(panel);
      schedulePanelMasonry(panel);
    }

    function closeViewer() {
      if (!viewer) return;
      viewer.hidden = true;
      document.body.classList.remove('film-archive-viewer-open');
      if (viewerImage) {
        viewerImage.removeAttribute('src');
        viewerImage.alt = '';
      }
      if (lastFocusedFrame) lastFocusedFrame.focus();
    }

    function openViewer(frame) {
      if (!viewer || !viewerImage) return;
      var image = frame.querySelector('img');
      if (!image) return;

      lastFocusedFrame = frame;
      viewerImage.src = image.currentSrc || image.src;
      viewerImage.alt = image.alt || frame.dataset.filmName || 'Film archive image';
      if (viewerFilm) viewerFilm.textContent = frame.dataset.filmName || 'Film details pending';
      if (viewerExpired && viewerExpiredRow) {
        viewerExpired.textContent = frame.dataset.filmExpired === 'true' ? 'Yes' : 'No';
        viewerExpiredRow.hidden = false;
      }
      if (viewerFormat && viewerFormatRow) {
        var filmFormat = frame.dataset.filmFormat || '';
        viewerFormat.textContent = filmFormat;
        viewerFormatRow.hidden = !filmFormat;
      }
      if (viewerRespool && viewerRespoolRow) {
        var respoolVariant = frame.dataset.frameRespoolVariant || '';
        viewerRespool.textContent = respoolVariant;
        viewerRespoolRow.hidden = !respoolVariant;
      }
      if (viewerIso) viewerIso.textContent = frame.dataset.frameIsoShotAt || 'N/A';
      if (viewerCredit) viewerCredit.textContent = frame.dataset.frameCredit || 'Credit pending';
      if (viewerProcess) viewerProcess.textContent = frame.dataset.frameFilmProcess || frame.dataset.frameProcess || 'Processing details pending';
      if (viewerLab && viewerLabRow) {
        var filmLab = frame.dataset.frameFilmLab || '';
        viewerLab.textContent = filmLab;
        viewerLabRow.hidden = !filmLab;
      }
      if (viewerPush) viewerPush.textContent = frame.dataset.framePush || 'N/A';
      if (viewerNotes && viewerNotesRow) {
        var notes = frame.dataset.frameNotes || '';
        viewerNotes.textContent = notes;
        viewerNotesRow.hidden = !notes;
      }
      if (viewerBuy) {
        var request = ++viewerRequest;
        var filmProductUrl = frame.dataset.filmUrl || '';
        viewerBuy.hidden = !filmProductUrl;
        if (filmProductUrl) {
          viewerBuy.href = filmProductUrl;
          viewerBuy.setAttribute('aria-label', 'Buy ' + (frame.dataset.filmName || 'this film'));
        } else {
          findFilmProduct(frame).then(function (url) {
            if (url) frame.dataset.filmUrl = url;
            if (request !== viewerRequest || !url) return;
            viewerBuy.href = url;
            viewerBuy.setAttribute('aria-label', 'Buy ' + frame.dataset.filmName);
            viewerBuy.hidden = false;
          }).catch(function () {
            // Keep unavailable links hidden; the next opening can retry.
          });
        }
      }

      viewer.hidden = false;
      document.body.classList.add('film-archive-viewer-open');
      if (viewerClose) viewerClose.focus();
    }

    function updateBackTopVisibility() {
      if (!backTop) return;
      backTop.hidden = window.scrollY < Math.max(window.innerHeight * 0.35, 220);
    }

    function setActive(category) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.filmArchiveTab === category;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });

      panels.forEach(function (panel) {
        var active = panel.dataset.filmArchivePanel === category;
        panel.hidden = !active;
        if (active) {
          panel.dataset.filmArchiveSelectedSlug = '';
          panel.dataset.filmArchiveSelectedFormat = '';
          panel.dataset.filmArchiveSelectedStatus = '';
          resetPanelLimit(panel);
          shufflePanelFrames(panel, getPanelFrameMatcher(panel));
          filterPanel(panel, '', 'Choose a film');
        }
      });
    }

    function isProtectedImageTarget(target) {
      return Boolean(target && target.closest && target.closest('[data-film-archive-frame], [data-film-archive-viewer] img'));
    }

    root.addEventListener('click', function (event) {
      var tab = event.target && event.target.closest ? event.target.closest('[data-film-archive-tab]') : null;
      if (tab && root.contains(tab)) {
        event.preventDefault();
        setActive(tab.dataset.filmArchiveTab);
        return;
      }

      if (event.target && event.target.closest && event.target.closest('.film-archive__tabs, .film-archive__panel-head, [data-film-archive-dropdown]')) return;
      var frame = event.target && event.target.closest ? event.target.closest('[data-film-archive-frame]') : null;
      if (!frame || !root.contains(frame)) return;
      openViewer(frame);
    });

    root.addEventListener('contextmenu', function (event) {
      if (!isProtectedImageTarget(event.target)) return;
      event.preventDefault();
    });

    root.addEventListener('dragstart', function (event) {
      if (!isProtectedImageTarget(event.target)) return;
      event.preventDefault();
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActive(tab.dataset.filmArchiveTab);
      });
    });

    root.querySelectorAll('[data-film-archive-dropdown]').forEach(function (dropdown) {
      var panel = dropdown.closest('[data-film-archive-panel]');
      var toggle = dropdown.querySelector('[data-film-archive-dropdown-toggle]');
      var menu = dropdown.querySelector('[data-film-archive-dropdown-menu]');
      var search = dropdown.querySelector('[data-film-archive-search]');
      var options = dropdown.querySelectorAll('[data-film-archive-option]');

      if (!panel || !toggle || !menu) return;

      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-film-archive-dropdown]').forEach(function (otherDropdown) {
          if (otherDropdown !== dropdown) closeDropdown(otherDropdown);
        });

        toggle.setAttribute('aria-expanded', String(!isOpen));
        menu.hidden = isOpen;
        if (!isOpen && search) {
          search.value = '';
          options.forEach(function (option) {
            option.hidden = option.dataset.filmArchiveHasFrames === 'false';
          });
          search.focus();
        }
      });

      if (search) {
        search.addEventListener('input', function () {
          var query = search.value.trim().toLowerCase();
          options.forEach(function (option) {
            var hasFrames = option.dataset.filmArchiveHasFrames !== 'false';
            var matchesSearch = !query || option.textContent.toLowerCase().indexOf(query) !== -1;
            option.hidden = !hasFrames || !matchesSearch;
          });
        });
      }

      options.forEach(function (option) {
        option.addEventListener('click', function (event) {
          event.stopPropagation();
          var kind = dropdown.dataset.filmFilterKind || 'film';
          var slug = option.dataset.filmSlug || '';
          var label = slug ? option.textContent.trim() : 'Choose a film';

          if (kind === 'film') panel.dataset.filmArchiveSelectedSlug = slug;
          if (kind === 'format') panel.dataset.filmArchiveSelectedFormat = option.dataset.filmFilterValue || '';
          if (kind === 'status') panel.dataset.filmArchiveSelectedStatus = option.dataset.filmFilterValue || '';
          resetPanelLimit(panel);
          shufflePanelFrames(panel, getPanelFrameMatcher(panel));
          options.forEach(function (otherOption) {
            otherOption.classList.toggle('is-active', otherOption === option);
          });

          filterPanel(panel, kind === 'film' ? slug : undefined, kind === 'film' ? label : undefined);
          closeDropdown(dropdown);
        });
      });
    });

    root.querySelectorAll('[data-film-archive-load-more]').forEach(function (button) {
      var panel = button.closest('[data-film-archive-panel]');
      if (!panel) return;

      button.addEventListener('click', function () {
        increasePanelLimit(panel);
      });
    });

    window.addEventListener('scroll', function () {
      updateBackTopVisibility();
    }, { passive: true });

    if (backTop) {
      backTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      updateBackTopVisibility();
    }

    document.addEventListener('click', function (event) {
      if (root.contains(event.target) && event.target.closest('[data-film-archive-dropdown]')) return;
      root.querySelectorAll('[data-film-archive-dropdown]').forEach(closeDropdown);
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeViewer();
        root.querySelectorAll('[data-film-archive-dropdown]').forEach(closeDropdown);
      }
    });

    root.querySelectorAll('[data-film-archive-frame]').forEach(function (frame) {
      frame.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openViewer(frame);
      });
      var frameImage = frame.querySelector('img');
      if (frameImage && !frameImage.complete) {
        frameImage.addEventListener('load', function () {
          var imagePanel = frame.closest('[data-film-archive-panel]');
          if (imagePanel && !imagePanel.hidden) schedulePanelMasonry(imagePanel);
        });
      }
    });

    var masonryResizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(masonryResizeTimer);
      masonryResizeTimer = window.setTimeout(function () {
        panels.forEach(function (panel) {
          if (!panel.hidden) layoutPanelMasonry(panel);
        });
      }, 100);
    });

    if (viewerClose) {
      viewerClose.addEventListener('click', closeViewer);
    }

    if (viewer) {
      viewer.addEventListener('click', function (event) {
        if (event.target === viewer) closeViewer();
      });
    }

    root.querySelectorAll('[data-film-archive-panel]').forEach(function (panel) {
      var countNode = panel.querySelector('[data-film-archive-count]');
      var imageCountNode = panel.querySelector('[data-film-archive-image-count]');
      var frames = Array.prototype.slice.call(panel.querySelectorAll('[data-film-archive-frame]'));
      var imageCount = frames.length;
      var filmSlugs = frames.reduce(function (slugs, frame) {
        if (frame.dataset.filmSlug && slugs.indexOf(frame.dataset.filmSlug) === -1) {
          slugs.push(frame.dataset.filmSlug);
        }
        return slugs;
      }, []);
      var count = filmSlugs.length;

      panel.querySelectorAll('[data-film-archive-option]').forEach(function (option) {
        var slug = option.dataset.filmSlug || '';
        var hasFrames = !slug || filmSlugs.indexOf(slug) !== -1 || option.dataset.filmForceVisible === 'true';
        option.dataset.filmArchiveHasFrames = String(hasFrames);
        option.hidden = !hasFrames;
      });

      resetPanelLimit(panel);
      updatePanelMeta(panel);
    });

    var requestedParams = new URLSearchParams(window.location.hash.replace(/^#/, '') || window.location.search);
    var requestedSlug = requestedParams.get('film') || '';
    var requestedSample = requestedParams.get('sample') || '';
    var requestedFormat = normalizeFilmFormat(requestedParams.get('format'));
    var requestedFrame = requestedSlug ? root.querySelector('[data-film-archive-frame][data-film-slug="' + CSS.escape(requestedSlug) + '"]') : null;
    if (!requestedFrame && requestedSample) {
      requestedFrame = Array.prototype.find.call(root.querySelectorAll('[data-film-archive-frame]'), function (frame) {
        var image = frame.querySelector('img');
        var imageSource = image ? (image.currentSrc || image.getAttribute('src') || '') : '';
        return imageSource.indexOf(requestedSample) !== -1;
      }) || null;
    }
    if (requestedFrame && requestedFrame.dataset.filmSlug) {
      requestedSlug = requestedFrame.dataset.filmSlug;
    }
    var requestedPanel = requestedFrame && requestedFrame.closest('[data-film-archive-panel]');
    var firstTab = tabs[0];

    if (requestedPanel) {
      var requestedCategory = requestedPanel.dataset.filmArchivePanel;
      setActive(requestedCategory);
      requestedPanel.dataset.filmArchiveSelectedSlug = requestedSlug;
      requestedPanel.dataset.filmArchiveSelectedFormat = requestedFormat;
      requestedPanel.dataset.filmArchiveSelectedStatus = '';
      resetPanelLimit(requestedPanel);
      shufflePanelFrames(requestedPanel, getPanelFrameMatcher(requestedPanel));
      var requestedOption = requestedPanel.querySelector('[data-film-filter-kind="film"] [data-film-archive-option][data-film-slug="' + CSS.escape(requestedSlug) + '"]');
      requestedPanel.querySelectorAll('[data-film-filter-kind="film"] [data-film-archive-option]').forEach(function (option) {
        option.classList.toggle('is-active', option === requestedOption);
      });
      requestedPanel.querySelectorAll('[data-film-filter-kind="format"] [data-film-archive-option]').forEach(function (option) {
        option.classList.toggle('is-active', option.dataset.filmFilterValue === requestedFormat);
      });
      filterPanel(requestedPanel, requestedSlug, requestedOption ? requestedOption.textContent.trim() : requestedFrame.dataset.filmName);
    } else if (firstTab) {
      setActive(firstTab.dataset.filmArchiveTab);
    }
    root.dataset.filmArchiveInitialized = 'true';
    } catch (error) {
      delete root.dataset.filmArchiveInitialized;
      console.error('Film archive could not initialize', error);
    }
  }

  function initializeArchives() {
    var roots = document.querySelectorAll('[data-film-archive]');
    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeArchives);
  } else {
    initializeArchives();
  }
  window.addEventListener('load', initializeArchives);
  setTimeout(initializeArchives, 0);
  setTimeout(initializeArchives, 250);

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-film-archive]').forEach(shuffleArchiveFrames);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    document.querySelectorAll('[data-film-archive]').forEach(shuffleArchiveFrames);
  });
})();
